// SFMC-flavored text overrides for the shared Simulator step components
// (used by both the standalone SFMC Interactive Simulator and SFMC Case Studies).
export const SFMC_SIMULATOR_TERMS = {
  streamsTitle: "Step 2 — Import to Data Extensions",
  streamsDescription: "For each connected source, choose the correct Data Extension type to import into via Automation Studio.",
  mappingTitle: "Step 3 — Field Mapping to Data Extensions",
  mappingDescription: "Drag a source field onto its matching Data Extension target field — or tap a source field, then tap the target to map it.",
  mappingTargetSectionLabel: "Data Extension Target Fields",
  identityTitle: "Step 4 — Contact Model Linking Rules",
  identityDescription: "Select the matching rules that should link records into one Contact via Contact Builder, without creating false merges.",
  unifiedTitle: "Step 5 — Unified Contact Profile",
  unifiedDescription: "Based on your connections, mappings, and linking rules so far, Contact Builder would generate one Unified Contact profile like this. Click \"Check My Work\" to have the AI validate your pipeline quality.",
  unifiedEntityLabel: "Unified Contact",
  unifiedFieldUnitLabel: "Data Extension field",
  segmentStepTitle: "Step 6a — Build an Audience",
  insightStepTitle: "Step 6b — Build a Personalization Insight",
  activateTitle: "Step 7 — Activate",
  activateDescription: "Review your full pipeline, then publish the Audience to a Journey Builder entry source or Send Classification for this business scenario.",
};
